import React from 'react'
import styled from 'styled-components'
import { Feature } from 'geojson'
import { extraPropertiesFormatterMap, notExtraProperties } from './constants'

const WrapperInfoWindow = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 140px;
  overflow-y: auto;

  h3 {
    margin: 0 0 10px;
    padding-right: 15px;
    font-size: 14px;
    line-height: 14px;
  }

  div.info-window-content {
    display: flex;
    flex: 1;
    flex-direction: column;

    .property-title {
      font-weight: bold;
      font-size: 12px;
      line-height: 12px;
    }

    .property-value {
      padding-bottom: 5px;
      font-size: 12px;
      line-height: 12px;
    }
  }
`

/**
 * Afere janelas de informações às features em mapa, respeitando as propriedades já mapeadas para serem listadas em `extraProperties`
 */
export const ItineraryInfoWindow = ({
  feature,
}: {
  /**Feature que se deseja adicionar uma infoWindow */
  feature: Feature
  /** Altura máxima da infoWindow */
  maxHeight: string | undefined
}) => {
  const { name } = (feature.properties || {}) as { name?: string }

  const extraProperties = {
    ...(feature.properties || {}),
  } as Record<string, string | number | undefined>

  notExtraProperties.forEach(key => {
    delete extraProperties[key]
  })

  const sortedProperties = Object.keys(extraProperties)
    .filter(property =>
      Boolean(extraPropertiesFormatterMap[property as keyof typeof extraPropertiesFormatterMap]),
    )
    .sort((propertyA, propertyB) => {
      const formatterA =
        extraPropertiesFormatterMap[propertyA as keyof typeof extraPropertiesFormatterMap]
      const formatterB =
        extraPropertiesFormatterMap[propertyB as keyof typeof extraPropertiesFormatterMap]

      const orderA = formatterA?.order ?? Number.MAX_SAFE_INTEGER
      const orderB = formatterB?.order ?? Number.MAX_SAFE_INTEGER

      if (orderA !== orderB) {
        return orderA - orderB
      }

      return formatterA.label.localeCompare(formatterB.label)
    })

  return (
    <WrapperInfoWindow>
      <h3>{name}</h3>
      <div style={{ overflowY: 'scroll' }}>
        {sortedProperties.map(property => {
          const formatter =
            extraPropertiesFormatterMap[property as keyof typeof extraPropertiesFormatterMap]

          return (
            <div className='info-window-content' key={property}>
              <span className='property-title'>{formatter.label}</span>
              <span className='property-value'>{formatter.format(extraProperties[property])}</span>
            </div>
          )
        })}
      </div>
    </WrapperInfoWindow>
  )
}
